import '../../App.css';
import svg14 from '../../img/svg/icn_14.svg';
import svg12 from '../../img/svg/icn_12.svg';
import svg13 from '../../img/svg/icn_13.svg';
import svg11 from '../../img/svg/icn_11.svg';
import svg15 from '../../img/svg/icn_15.svg';
import bg1 from '../../img/bg1.jpg';
import { ReactComponent as Logo } from '../../img/svg/icn_11.svg';

const sedes_icon = [
  { icon: svg14, id: 1 },
  { icon: svg12, id: 4 },
  { icon: svg11, id: 5 },
  { icon: svg13, id: 7 },
  { icon: svg15, id: 3 },
];
function Step4({ setPage, setSede, sede, carrera,setCarreraModalidadSede,carrera_modalidad_sede }) {
  const getIcon = (id) => {
    return sedes_icon.find((i) => i.id === id).icon;
  };

  return (
    <section class="step style--2">
      <div class="section--bg img--bg ">
        <img class="first" src={bg1} alt="" />
      </div>
      <div class="in">
        <header class="marquee">
          <div class="in">
            <div class="maxwidth">
              <div class="logo gone"></div>
              <div class="ttl">
                <span class="num fonty"></span>
                <h2>Elige tu sede</h2>
              </div>
              <div class="air gone"></div>
            </div>
          </div>
        </header>
        <main>
          <div class="maxwidth2">
            <div class="ttl text--center big titular">
              ¿En qué sede <b className="bold_letter">te gustaría estudiar?</b>
            </div>
          </div>
          <div class="maxwidth2 padded--left padded--right">
            <div class="filterable text--uppercase required empty">
              <ul>
                {carrera.carrera_modalidad_sede.map((s) => {
                  return (
                    <>
                      <li
                        class="submit"
                        onClick={() => {
                          setSede(s.sede.id_sede);
                          setCarreraModalidadSede(s.id_carrera_modalidad_sede)
                          setPage(6);
                        }}
                      >
                        <button className="red_button" id={s.id_carrera_modalidad_sede} name={s.id_carrera_modalidad_sede}>
                          <span className={carrera_modalidad_sede === s.id_carrera_modalidad_sede ? "icn icn_ selected_icon"  : "icn icn_"}>
                            <span className={carrera_modalidad_sede === s.id_carrera_modalidad_sede ? "selected" : ""}>
                              {s.sede.url_icono_sede === null ? <>
                                <Logo alt="" fill={carrera_modalidad_sede === s.id_carrera_modalidad_sede ? "white" : "#e23038"}/>
                              </>:<>
                                <img alt="" src={s.sede.url_icono_sede} className={carrera_modalidad_sede === s.id_carrera_modalidad_sede ? 'sgv_icon_selected' : 'svg_icon'}/>
                              </>}      
                            </span>
                          </span>
                          <span className={carrera_modalidad_sede === s.id_carrera_modalidad_sede ? "name selected_name" : "name"}>
                            {s.sede.nombre_sede}
                            {/* <><span class="bajada">
														{s.campus}
													</span></>*/}
                          </span>
                        </button>
                      </li>
                    </>
                  );
                })}
              </ul>
            </div>
          </div>
        </main>
      </div>
    </section>
  );
}

export default Step4;
